export default "__VITE_ASSET__9ab44296__"